'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _puckCore = require('@alife/puck-core');

var _puckCore2 = _interopRequireDefault(_puckCore);

var _puckCsrftoken = require('@alife/puck-csrftoken');

var _puckCsrftoken2 = _interopRequireDefault(_puckCsrftoken);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by @玩家 on 16/7/6.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var Puck = function (_Core) {
    _inherits(Puck, _Core);

    function Puck(options) {
        _classCallCheck(this, Puck);

        // 加载监控中间件
        var _this = _possibleConstructorReturn(this, _Core.call(this, options));

        _this.use(_puckCsrftoken2['default']);
        return _this;
    }

    /**
     * iframe快捷请求方式
     * @param {string} url - 资源地址
     * @param {object} options - 配置项
     * @returns {Promise}
     */


    Puck.prototype.iframe = function iframe(url, options) {
        return this.request(url, _extends({}, options, {
            type: 'iframe'
        }));
    };

    return Puck;
}(_puckCore2['default']);

Puck.version = '3.0.4';


var puck = new Puck();
exports['default'] = puck;
module.exports = exports['default'];